export default __webpack_public_path__ + "static/media/29.03a3eb1f.jpg";